var map = {
	"./angle-left-b.svg": 5755,
	"./angle-right-b.svg": 4920,
	"./arrow-down.svg": 515,
	"./arrow-up.svg": 1948,
	"./bars.svg": 721,
	"./briefcase-alt.svg": 9035,
	"./building.svg": 7223,
	"./check.svg": 8685,
	"./clipboard-notes.svg": 6427,
	"./content.svg": 3974,
	"./cube.svg": 6024,
	"./cyclorama.svg": 1224,
	"./draggabledots.svg": 6272,
	"./estate.svg": 1479,
	"./folder.svg": 1903,
	"./gallery.svg": 4719,
	"./images.svg": 6705,
	"./import.svg": 1404,
	"./letter.svg": 4831,
	"./logo.svg": 9438,
	"./orbital.svg": 9174,
	"./pen.svg": 6632,
	"./plus.svg": 5143,
	"./presentation-play.svg": 6394,
	"./search.svg": 7371,
	"./setting.svg": 9681,
	"./times.svg": 7751,
	"./tour.svg": 5465,
	"./transaction.svg": 5529,
	"./users.svg": 9337,
	"./video.svg": 3396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5312;